document.addEventListener('DOMContentLoaded',function(){
  var header=document.getElementById('siteHeader');
  var menuBtn=document.getElementById('menuBtn');
  var mobileNav=document.getElementById('mobileNav');
  var mobileClose=document.getElementById('mobileMenuClose');

  function onScroll(){
    if(header){
      if(window.scrollY>8){header.classList.add('scrolled')}else{header.classList.remove('scrolled')}
    }
  }
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  function setMenu(open){
    if(!mobileNav||!menuBtn) return;
    mobileNav.classList.toggle('open',open);
    document.body.classList.toggle('menu-open',open);
    menuBtn.textContent=open?'×':'☰';
    menuBtn.setAttribute('aria-expanded',open?'true':'false');
  }
  if(menuBtn&&mobileNav){
    menuBtn.addEventListener('click',function(){setMenu(!mobileNav.classList.contains('open'))});
    mobileNav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){setMenu(false)})});
  }
  if(mobileClose){mobileClose.addEventListener('click',function(){setMenu(false)})}

  document.querySelectorAll('.qty-stepper').forEach(function(stepper){
    var input=stepper.querySelector('input');
    var minus=stepper.querySelector('.qty-minus');
    var plus=stepper.querySelector('.qty-plus');
    if(minus) minus.addEventListener('click',function(){input.value=Math.max(0,(parseInt(input.value||'0',10)-1));input.dispatchEvent(new Event('change',{bubbles:true}))});
    if(plus) plus.addEventListener('click',function(){input.value=(parseInt(input.value||'0',10)+1);input.dispatchEvent(new Event('change',{bubbles:true}))});
  });

  var sizeGuideLink=document.getElementById('sizeGuideLink');
  var sizeGuide=document.getElementById('size-guide');
  if(sizeGuideLink&&sizeGuide){
    sizeGuideLink.addEventListener('click',function(){
      sizeGuide.open=true;
      setTimeout(function(){sizeGuide.scrollIntoView({behavior:'smooth',block:'start'})},20);
    });
  }

  var radios=document.querySelectorAll('#product-form input[type="radio"][name="id"]');
  var mainAdd=document.getElementById('mainAddButton');
  var stickyBtn=document.getElementById('stickyBuyButton');
  var sizeSelector=document.getElementById('sizeSelector');
  if(radios.length){
    radios.forEach(function(r){
      r.addEventListener('change',function(){
        if(mainAdd){mainAdd.disabled=false;mainAdd.textContent='ADD TO BAG'}
        if(stickyBtn){stickyBtn.disabled=false;stickyBtn.textContent='ADD TO BAG'}
      });
    });
  }
  if(stickyBtn){
    stickyBtn.addEventListener('click',function(){
      if(stickyBtn.disabled){
        if(sizeSelector) sizeSelector.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      if(mainAdd) mainAdd.click();
    });
  }

  var gallery=document.getElementById('productGallery');
  var dots=document.querySelectorAll('#galleryDots span');
  if(gallery&&dots.length){
    gallery.addEventListener('scroll',function(){
      var index=Math.round(gallery.scrollLeft/gallery.clientWidth);
      dots.forEach(function(d,i){d.classList.toggle('active',i===index)});
    },{passive:true});
  }

  var galleryItems=Array.from(document.querySelectorAll('.product-gallery-item'));
  var lightbox=document.getElementById('productLightbox');
  var lightboxImage=document.getElementById('lightboxImage');
  var lightboxClose=document.getElementById('lightboxClose');
  var lightboxPrev=document.getElementById('lightboxPrev');
  var lightboxNext=document.getElementById('lightboxNext');
  var lightboxCounter=document.getElementById('lightboxCounter');
  var activeLightboxIndex=0;

  function renderLightbox(index){
    if(!galleryItems.length||!lightboxImage) return;
    activeLightboxIndex=(index+galleryItems.length)%galleryItems.length;
    var item=galleryItems[activeLightboxIndex];
    lightboxImage.src=item.getAttribute('data-full-image');
    if(lightboxCounter) lightboxCounter.textContent=(activeLightboxIndex+1)+' / '+galleryItems.length;
  }
  function openLightbox(index){
    if(!lightbox) return;
    renderLightbox(index);
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden','false');
    document.body.classList.add('lightbox-open');
    if(lightboxClose) lightboxClose.focus();
  }
  function closeLightbox(){
    if(!lightbox) return;
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden','true');
    document.body.classList.remove('lightbox-open');
  }
  galleryItems.forEach(function(item,index){
    item.addEventListener('click',function(){openLightbox(index)});
  });
  if(lightboxClose) lightboxClose.addEventListener('click',closeLightbox);
  if(lightboxPrev) lightboxPrev.addEventListener('click',function(){renderLightbox(activeLightboxIndex-1)});
  if(lightboxNext) lightboxNext.addEventListener('click',function(){renderLightbox(activeLightboxIndex+1)});
  if(lightbox){
    lightbox.addEventListener('click',function(e){if(e.target===lightbox) closeLightbox()});
  }
  document.addEventListener('keydown',function(e){
    if(!lightbox||!lightbox.classList.contains('open')) return;
    if(e.key==='Escape') closeLightbox();
    if(e.key==='ArrowLeft') renderLightbox(activeLightboxIndex-1);
    if(e.key==='ArrowRight') renderLightbox(activeLightboxIndex+1);
  });

  var hoverZoom=document.getElementById('hoverZoomPreview');
  var canHover=window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:901px)').matches;

  function placeHoverZoom(item){
    if(!hoverZoom) return;
    var rect=item.getBoundingClientRect();
    var panelW=Math.min(window.innerWidth*0.46,560);
    var panelH=Math.min(window.innerHeight*0.72,650);
    var gap=18;
    var left=rect.right+gap;
    if(left+panelW>window.innerWidth-12){
      left=rect.left-panelW-gap;
    }
    if(left<12) left=12;
    var top=Math.max(12,Math.min(rect.top,window.innerHeight-panelH-12));
    hoverZoom.style.left=left+'px';
    hoverZoom.style.top=top+'px';
  }

  if(canHover&&hoverZoom){
    galleryItems.forEach(function(item){
      item.addEventListener('mouseenter',function(){
        var full=item.getAttribute('data-full-image');
        if(!full) return;
        hoverZoom.style.backgroundImage='url("'+full+'")';
        hoverZoom.style.backgroundSize='260% auto';
        placeHoverZoom(item);
        hoverZoom.classList.add('active');
        hoverZoom.setAttribute('aria-hidden','false');
        item.classList.add('zooming');
      });

      item.addEventListener('mousemove',function(e){
        var rect=item.getBoundingClientRect();
        var x=Math.max(0,Math.min(1,(e.clientX-rect.left)/rect.width));
        var y=Math.max(0,Math.min(1,(e.clientY-rect.top)/rect.height));
        hoverZoom.style.backgroundPosition=(x*100)+'% '+(y*100)+'%';
        item.style.setProperty('--lens-x',(x*100)+'%');
        item.style.setProperty('--lens-y',(y*100)+'%');
        placeHoverZoom(item);
      });

      item.addEventListener('mouseleave',function(){
        hoverZoom.classList.remove('active');
        hoverZoom.setAttribute('aria-hidden','true');
        item.classList.remove('zooming');
      });
    });

    window.addEventListener('scroll',function(){
      hoverZoom.classList.remove('active');
      galleryItems.forEach(function(item){item.classList.remove('zooming')});
    },{passive:true});
  }
});
